import { Newspaper, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const Footer = () => {
  const navigate = useNavigate();
  const handleBlogClick = () => {
    navigate('/blog');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return <footer className="bg-card border-t border-border py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center">
          <div className="text-3xl font-serif font-bold text-foreground mb-4">
            Mystic Forest
          </div>
          <p className="text-muted-foreground mb-8">Because even the offline need a little online — connect with us here.</p>
          
          {/* Social Links */}
          <div className="flex justify-center items-center space-x-6 mb-8">
            <button 
              onClick={handleBlogClick} 
              className="text-muted-foreground hover:text-accent transition-colors group"
              aria-label="Visit our blog"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center group-hover:shadow-lg transition-shadow">
                <Newspaper className="w-8 h-8 text-white" />
              </div>
            </button>
            
            <a 
              href="https://www.instagram.com/mysticforest.club" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="cursor-pointer"
              aria-label="Follow us on Instagram"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 rounded-full flex items-center justify-center hover:shadow-lg transition-shadow">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </div>
            </a>

            <a 
              href="mailto:hello@mysticforest.club" 
              className="cursor-pointer"
              aria-label="Send us an email"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-gray-500 to-gray-600 rounded-full flex items-center justify-center hover:shadow-lg transition-shadow">
                <Mail className="w-8 h-8 text-white" />
              </div>
            </a>
          </div>
          
          <div className="border-t border-border pt-8">
            <p className="text-sm text-muted-foreground mb-2">
              © 2025 Mystic Forest. All rights reserved.
            </p>
            <div className="flex justify-center gap-4 mb-4 text-sm">
              <button
                onClick={() => navigate('/privacy-policy')}
                className="text-muted-foreground hover:text-accent transition-colors"
              >
                Privacy Policy
              </button>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed">
              The Mystic Forest brand, concept, methodology, and all original content including retreat formats, 
              workshop designs, and community-building approaches are protected by copyright and intellectual property laws. 
              Unauthorized reproduction, distribution, or use of our proprietary methods is strictly prohibited.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};